import { isWeb } from '@commonStyle';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8fafc',
    paddingHorizontal: 20,
    paddingTop: 40,
  },
  
  titre: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1e293b',
    textAlign: 'center',
    marginBottom: 30,
    letterSpacing: -0.5,
  },
  
  pressableItem: {
    padding: 20,
    borderRadius: 16,
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    flexDirection: 'column',
    gap: 18,
    width: isWeb ? '65%' : '100%',
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  
  pressableItemActive: {
    backgroundColor: '#f0f9ff',
    borderColor: '#0ea5e9',
    transform: [{ scale: 0.98 }],
  },
  
  listContent: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  tenantName: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 4,
  },

  agentService: {
    fontSize: 16,
    color: '#6B7280',    
  },

  agentDate: {
    fontSize: 16,
    color: '#000000',    
  },
  
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 60,
  },
  
  emptyText: {
    fontSize: 16,
    color: '#94a3b8',
    textAlign: 'center',
    lineHeight: 24,
  },
});

export default styles;